export default __webpack_public_path__ + "static/media/dalenrestaurant.91908fa9.jpg";